(() => {
  const group = document.querySelector('.main-product__details-wrapper--sticky .main-product__details-sticky-group');

  if (!group) {
    return;
  }

  const topEl = group.querySelector('.main-product__details-top');
  const bottomEl = group.querySelector('.main-product__details-bottom');

  if (!topEl || !bottomEl) {
    return;
  }

  let ticking = false;

  const update = () => {
    ticking = false;
    topEl.style.transform = '';

    if (window.innerWidth < 990) {
      return;
    }

    const overlap = topEl.getBoundingClientRect().bottom - bottomEl.getBoundingClientRect().top;

    if (overlap > 0) {
      topEl.style.transform = `translateY(${-overlap}px)`;
    }
  };

  const requestUpdate = () => {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(update);
  };

  requestUpdate();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);

  if (window.ResizeObserver) {
    const observer = new ResizeObserver(requestUpdate);
    observer.observe(topEl);
    observer.observe(bottomEl);
  }
})();
